module.exports = __webpack_public_path__ + "media/images/icon/algo-b50c8f34cd1c6b487ab567b64b9e9a3c.svg";